/* Model */
class TagModel extends App.Models.BaseModel {
    modelUrl = 'Tag';
}

App.Models.Tag = TagModel;

/* Collection */
class TagCollection extends App.Collections.BaseCollection {
    url = 'Tag';
    model = App.Models.Tag;
}

App.Collections.Tags = TagCollection;

/* Router */
class TagRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Tag';
        const model = App.Models.Tag;
        const collectionClass = App.Collections.Tags;

        super(entityName, model, collectionClass);

        this.rendered = {};
        this.listRouteTags = Greenmile.Utils.getListRouteTags();
        this.listStopTags = Greenmile.Utils.getListStopTags();
    }

    handleInconsistentFields = () => {
        const tagForm = App.Forms.Tag.form.fields;
        tagForm.enabled.setMandatory(false);

        if (this.crudStage === 'edit') {
            tagForm.tagType.disable();
        }
    }

    afterCreateForm = (entity, formData, crudStage) => {
        Monet.Session.Tag = {};
        const selector = App.Forms.Tag.form.getSections()[2].key;

        this.addDivFields();
        this.makeDefaultCheckboxEnabledTrue(crudStage);
        this.addListenerOnTagType();
        this.renderTagWhen(selector);
        this.renderFiltersField(selector);
        this.renderUnTagWhen(selector);
        this.renderAlsoUnTag(selector);
        this.handleInconsistentFields();
    }

    addDivFields = () => {
        const divTags   = document.querySelector('#Tag div[key="' + App.Forms.Tag.form.getSections()[2].key + '"]'),
            divFields = document.createElement('div'),
            divColumn = document.createElement('div');

        divFields.className = 'MonetUIFormSectionFields';
        divColumn.className = 'MonetUIFormSectionColumn';

        divColumn.setAttribute('sectioncolumn', 1);
        divFields.appendChild(divColumn);
        divTags.appendChild(divFields);
    }

    makeDefaultCheckboxEnabledTrue = (crudStage) => {
        const enabledTag = document.querySelector('#Tag #Tag_enabled .checkBoxField');
        if (crudStage === 'new') {
            enabledTag.checked = true;
        }
    }

    addListenerOnTagType = () => {
        Monet.Session.Tag.sectionSmartTag = document.querySelector('#Tag div[key="' + App.Forms.Tag.form.getSections()[2].key + '"]');
        App.Forms.Tag.form.fields.tagType.setListenerOnChange((e) => {
            Monet.Session.Tag.sectionSmartTag.classList[this.shouldShowConfig(e.target.value) ? 'add' : 'remove']('show');
        });
    }

    shouldShowConfig = (type) => type === 'EQUIPMENT' || type === 'ROUTE';

    getOptionValue = (key) => {
        return [{
            description:  Monet.I18n.getResourcesByKey(key),
            value: ''
        }];
    }

    renderTagWhen = (selector) => {
        const divTag = document.querySelector('#Tag div[key="' + selector + '"] .MonetUIFormSectionColumn');
        const comboTagWhen = new Monet.UI.Fields.PickList();
        const selectEventPlaceholder = this.getOptionValue('tag.label.selectEventPlaceholder');
        let allTags = [];
       
        allTags = allTags.concat(selectEventPlaceholder);
        allTags = allTags.concat(this.listRouteTags);
        allTags = allTags.concat(this.listStopTags);

        comboTagWhen.createElement();
        comboTagWhen.setTextLabel(Monet.I18n.getResourcesByKey('tag.TagWhen'));
        comboTagWhen.setData(allTags);
        comboTagWhen.input.id = 'tagWHen';
        comboTagWhen.input.setAttribute('class', 'tagSelect');
        comboTagWhen.input.setAttribute('required', true);
        comboTagWhen.rootEl.setAttribute("class", "MonetUIFieldPicker");

        divTag.appendChild(comboTagWhen.rootEl);
        App.Forms.Tag.form.fields.tagWhen = comboTagWhen;
    }

    renderUnTagWhen = (selector) => {
        const divTag = document.querySelector('#Tag div[key="' + selector + '"] .MonetUIFormSectionColumn');
        const comboUnTagWhen = new Monet.UI.Fields.PickList();
        const chooseEventPlaceholder = this.getOptionValue('tag.label.chooseEventPlaceholder');
        let tagsToShow = [];
        
        tagsToShow = tagsToShow.concat(chooseEventPlaceholder);
        tagsToShow = tagsToShow.concat(this.listRouteTags);
        tagsToShow = tagsToShow.concat(this.listStopTags);
        
        comboUnTagWhen.createElement();
        comboUnTagWhen.setTextLabel(Monet.I18n.getResourcesByKey('tag.UnTagWhen'));
        comboUnTagWhen.input.id = 'unTagWHen';
        comboUnTagWhen.input.setAttribute('class', 'tagSelect');
        comboUnTagWhen.setData(tagsToShow);
        comboUnTagWhen.rootEl.setAttribute("class", "MonetUIFieldPicker");
        comboUnTagWhen.input.setAttribute('required', true); 

        divTag.appendChild(comboUnTagWhen.rootEl);
        App.Forms.Tag.form.fields.unTagWhen = comboUnTagWhen;
    }

    onValidate = () => {
        var validate = new Greenmile.Tag.ValidationTag(), idTagEdit = '';
        if (this.form_edit) {
            idTagEdit = this.form_edit.id;
        }
        validate.validateSmartTag(this.allow_submit, idTagEdit);
    }

    renderAlsoUnTag = (selector) => {
        const placeholderTag = Monet.I18n.getResourcesByKey('tag.label.selectTagsPlaceholder');
        const divTag = document.querySelector('#Tag div[key="' + selector + '"] .MonetUIFormSectionColumn');
        const lookupListAlsoUntag = new Monet.UI.Fields.PowerLookupList();
        lookupListAlsoUntag.setLookUpEntity('Tag');
        lookupListAlsoUntag.setNameSpace('Tag');
        lookupListAlsoUntag.setDisplayKey('description');
        lookupListAlsoUntag.createBaseStructure();
        lookupListAlsoUntag.setTextLabel(Monet.I18n.getResourcesByKey('tag.alsoUntag'));
        divTag.appendChild(lookupListAlsoUntag.render());
        lookupListAlsoUntag.setPlaceHolder(placeholderTag);
        lookupListAlsoUntag.formattedValue.placeholder = placeholderTag;
        lookupListAlsoUntag.rootEl.classList.add('clearAdditionalTagsField');

        App.Forms.Tag.form.fields.untagAlso = lookupListAlsoUntag;
    }

    renderFiltersField = (selector) => {
        const divTag = document.querySelector('#Tag div[key="' + selector + '"] .MonetUIFormSectionColumn');
        const filtersField = new Greenmile.Tag.FiltersField();
        filtersField.setTextLabel(Monet.I18n.getResourcesByKey('tag.condition'));
        filtersField.setRequiredToOperatorInput();
        filtersField.setPlacehoderSelectAnInformation(
            Monet.I18n.getResourcesByKey('tag.label.selectAnInformationPlaceholder')
        );
        filtersField.setPlaceholderInsertValue(
            Monet.I18n.getResourcesByKey('tag.label.insertAValuePlaceholder')
        );
        divTag.appendChild(filtersField.render());
        App.Forms.Tag.form.fields.jsonParameter = filtersField;
    };

    afterPopulateForm = (model) => {
        if (this.crudStage !== "index" && this.shouldShowConfig(model.attributes.tagType)) {
            Monet.Session.Tag.sectionSmartTag.classList.add('show');
        }
    };

    beforePopulateLocalCollection = () => {
        this.projection = '{"filters":["*", "untagAlso.*"]}';
    };
}

App.Routers.Tag = TagRouter;
